import firebase from 'firebase'
import BackendService from './BackendService'
import Company , { CompanyUser } from '@/models/Company'

export default class CompanyService extends BackendService {

  async createCompany (ownerId: string, companyName: string, companyNumber: string) {
    const dt = new Date();
    return await this.$db
      .collection('companies')
      .add({
        ownerId,
        companyName,
        companyNumber,
        added: dt,
        updated: dt,
        companyVerified: false,
      })
      .then(function (docRef: any) {
        return docRef.id
      })
      .catch((error: any) => {
        console.error('Error in createCompany', error)
      })
  }

  async addCompanyUser (companyId: string, userId: string, firstName: string, lastName: string, email: string, status: string, admin: boolean) {
    const batch = this.$db.batch()
    //return await this.$db


    // Set the company_user
    const companyUserRef = this.$db.collection('companies').doc(companyId).collection('company_users').doc(userId)
    const companyRef = this.$db.collection('companies').doc(companyId)

    // update
    batch.set(companyUserRef, {
        userId,
        companyId,
        firstName,
        lastName,
        email,
        status,
        admin,
        added: new Date()
      })
    batch.update(companyRef, {users: firebase.firestore.FieldValue.arrayUnion(userId), invites: firebase.firestore.FieldValue.arrayRemove(email)});

    // Commit the batch
    batch.commit()
      .then(() => {
        return true;
      })
      .catch((error: any) => {
        console.error('Error in BATCH for addCompanyUser', error)
        return false;
      })
  }

  async fetchCompanyByUserId (userId: string) {
    const arr: Array<Company> = []
    return await this.$db
      .collection('companies')
      .where('users', 'array-contains', userId)
      .get()
      .then((snap: any) => {
        snap.forEach((doc: any) => {
          const item = doc.data() as Company
          item.id = doc.ref.id
          item.added = doc.data().added ? doc.data().added.toDate() : null
          item.updated = doc.data().updated ? doc.data().updated.toDate() : null
          arr.push(item)
        })
        return arr;
      })
      .catch((error: any) => {
        console.log('Error in fetchCompanyByUserId', error)
        return false
      })
  }

  async fetchCompanyUsers (companyId: string) {
    return await this.$db
      .collection('companies')
      .doc(companyId)
      .collection('company_users')
      .get()
      .then((snap: any) => {
        const arr: Array<CompanyUser> = []
        snap.forEach((doc: any) => {
          const item = doc.data() as CompanyUser
          item.id = doc.ref.id
          item.added = doc.data().added ? doc.data().added.toDate() : null
          item.updated = doc.data().updated ? doc.data().updated.toDate() : null
          arr.push(item)
        })
        return arr;
      })
      .catch((error: any) => {
        console.log('Error in fetchCompanyByUserId', error)
        return false
      })
  }

  async updateCompany (item: Company) {
    item.added = new Date(item.added)
    item.updated = new Date()
    return await this.$db
      .collection('companies')
      .doc(item.id)
      .update(item)
      .then((result: any) => {
        return result
      })
      .catch((error: any) => {
        console.error('Error in editCompany', error)
        return false;
        
      })
  }

}
